<template>
  <div>
    <h1>河北遵睿数字科技有限公司</h1>
    <h2>一般项目：技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广；软件开发；软件销售；大数据服务；数字技术服务；数据处理服务；环境保护专用设备销售；包装材料及制品销售；五金产品零售；日用百货销售。（除依法须经批准的项目外，凭营业执照依法自主开展经营活动）许可项目：城市生活垃圾经营性服务。（依法须经批准的项目，经相关部门批准后方可开展经营活动，具体经营项目以相关部门批准文件或许可证件为准）</h2>
    <img src="@/assets/豆包.png"/>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {

  }
}
</script>

<style>

</style>
